import { PAGE_SIZE, MAX_PAGES } from '../../constants';

export const maxPagesLimit = (numOfGigs) => Math.min(Math.ceil(numOfGigs / PAGE_SIZE), MAX_PAGES);
